var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdditionalCardHolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M13.784 18.815h29.632a3.58 3.641 0 013.58 3.641v16.279c0 2.012-1.602 3.641-3.58 3.641H13.784c-1.979 0-3.58-1.63-3.58-3.641V22.456a3.58 3.641 0 013.58-3.64zm16.455 5.113h12.24m-3.861 9.335h3.861v3.926h-3.861v-3.926zm-19.223 2.01h2.413m2.417 0h2.413m2.417 0h2.413m-16.903 0h2.414m-6.754 5.477l-.755.13a1.57 1.597 0 01-1.805-1.308L4.345 19.48a1.572 1.598 0 011.285-1.835l33.195-5.673a1.572 1.598 0 011.805 1.307l.906 5.482"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalCardHolder);
export default __webpack_public_path__ + "static/media/additional-card-holder.77c704c2.svg";
export { ForwardRef as ReactComponent };